import * as React from 'react';

import Button from '../Button';
import { IModalProps, Modal } from '../Modal';

export interface IDeleteConfirmModalProps extends IModalProps {
  title?: string;
  onSave?: any;
}

const DeleteConfirmModal = ({ show, onClose, title, onSave }: IDeleteConfirmModalProps) => (
  <Modal show={show} className="success-modal" onClose={onClose}>
    <Modal.Header>
      <Modal.Title>
        <h5>{title}</h5>
      </Modal.Title>
      <Button bsClass="close" onClick={onClose}></Button>
    </Modal.Header>
    <Modal.Body>

    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose}>
        Close
      </Button>
      <Button onClick={onSave}>
        OK
      </Button>
    </Modal.Footer>
  </Modal>
);

export default DeleteConfirmModal;



// WEBPACK FOOTER //
// ./src/components/Modals/DeleteConfirmModal.tsx